module.exports = __webpack_public_path__ + "img/Eghtesad_Novin.55bd0d87.svg";